document.addEventListener('DOMContentLoaded', function () {
    let btn = document.getElementById('find-in-store-btn');
    let modal = document.getElementById('find-in-store');
    let closeBtn = document.querySelector('.find-a-store-popup-modal__toggle');

    btn.addEventListener('click', function (e) {
        e.preventDefault();
        modal.setAttribute('open', true);
    });

    closeBtn.addEventListener('click', function () {
        modal.removeAttribute('open');
    });

});
